(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["parwin-flash"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(b){
    if(b.__pp)return; b.__pp=1;
    var mins=parseInt(b.getAttribute('data-mins')||'9',10);
    var key='ppflash_'+(b.getAttribute('data-key')||'x');
    var now=Date.now(), end;
    try{ end=parseInt(sessionStorage.getItem(key)||'0',10); }catch(e){ end=0; }
    if(!end){ end=now+mins*60000; try{ sessionStorage.setItem(key,end); }catch(e){} }
    if(end<=now){ b.classList.add('pp-flash--ended'); return; }
    var t=b.querySelector('[data-pp-timer]');
    function p(n){return(n<10?'0':'')+n;}
    function tick(){ var d=end-Date.now(); if(d<=0){ b.classList.add('pp-flash--ended'); clearInterval(iv); return; } t.textContent=p(Math.floor(d/60000))+':'+p(Math.floor(d%60000/1000)); }
    var iv=setInterval(tick,1000); tick();
    var c=b.querySelector('[data-pp-code]');
    if(c){c.addEventListener('click',function(){
      var v=c.getAttribute('data-pp-code'),l=c.querySelector('[data-pp-copylabel]');
      function ok(){if(l){var s=l.textContent;l.textContent='Copied ✓';setTimeout(function(){l.textContent=s;},1500);}}
      if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(v).then(ok,ok);}
      else{try{var x=document.createElement('textarea');x.value=v;document.body.appendChild(x);x.select();document.execCommand('copy');document.body.removeChild(x);ok();}catch(e){}}
    });}
  }
  function run(){document.querySelectorAll('[data-pp-flash]').forEach(init);}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();
  } catch(e) { console.error(e); }
})();

})();
